import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('paymentsReport', [booksMenu])
  .controller('paymentsReportController', paymentsReportController)
  .name;
  
/* @ngInject */ function paymentsReportController($scope, BooksSvc, BusyScreen, Session) {
  /*-------------------*/
  /* Sets the defaults */
  /*-------------------*/
  $scope.req = { reportFormat: 'PDF', type: '' };
  $scope.reportPage = Session.getSessionURL('/PaymentsReport.aspx');

  /*-------------------------------*/
  /* Static array of payment types */
  /*-------------------------------*/
  $scope.types = [
    { type: '', label: 'All' },
    { type: 'CARD', label: 'Card' },
    { type: 'CHK', label: 'Check' },
    { type: 'CASH', label: 'Cash' },
    { type: 'CHNG', label: 'Change' },
    { type: 'FUND', label: 'Student Funds' },
    { type: 'WEB', label: 'Webstore' },
    { type: 'CWS', label: 'Community Webstore' }
  ];

  /*-------------------------------------------------------*/
  /* Works with CSMValidator to make sure that the start   */
  /* date and end date fields are populated and formatted. */
  /*-------------------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*****************************************************************************
   * getOrganization */
  /**
   * Returns current organization information.
   *****************************************************************************/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;
    BusyScreen.setBusy(false);
  });
}